<template>
  <div class="news">
    <link rel="stylesheet" href="https://pro.fontawesome.com/releases/v5.14.0/css/all.css" integrity="sha384-VhBcF/php0Z/P5ZxlxaEx1GwqTQVIBu4G4giRWxTKOCjTxsPFETUDdVL5B6vYvOt" crossorigin="anonymous">
    <div class="kroppensContainer">
      <div class="newsContainer">
        <div class="articles">
          <p class="heading" v-if="this.$root.admin">
            <font-awesome-icon :class="['settings', settingsMode ? 'active' : '']" @click="settingsMode = !settingsMode" v-if="this.$root.admin" :icon="['fas', 'cog']" />
          </p>
          <settingsComponent @newSettings="newSettings" v-if="settingsMode && this.$root.admin" :contentid="contentid" :saving="saving" :settings="this.$root.settings"></settingsComponent>
          <transition-group name="bounce">
            <article class="newsItem" v-for="(item, index) in items" :key="index+1">
              <a :href="basedir+item.urlPrefix+item.url.split('?')[0]"><img :alt="item.metaTitel" :src="basedir+item.imageUrl+'?w=286&quality=100'"></a>
              <div class="contentSnippet">
                <h5>{{item.metaTitel}}</h5>
                <p class="publicationDate">{{new Date(item.publicationDate).toLocaleDateString(locale, { year: 'numeric', month: 'numeric', day: 'numeric' }).replace(/\./g, '-')}}</p>
                <p>{{item.description.length > 100 ? item.description.slice(0, 100)+"..." : item.description}}</p>
                <a :href="basedir+item.urlPrefix+item.url.split('?')[0]"><webmessage searchKey="wsm_ReadMore" :text="$root.translations.wsm_ReadMore"></webmessage></a>
              </div>
              <script type="application/ld+json">
                  {
                      "@context": "http://schema.org",
                      "@type": "NewsArticle",
                      "mainEntityOfPage": {
                          "@type": "WebPage",
                          "@id": "{{location}}"
                      },
                      "headline": {{JSON.stringify(item.headers)}},
                      "image": [
                          "{{item.imageUrl.indexOf('http') < 0 ? location+urlPrefix+item.imageUrl : item.imageUrl}}"
                      ],
                      "datePublished": "{{new Date(item.publicationDate).toISOString().slice(0, 10)}}",
                      "dateModified": "{{new Date(item.publicationDate).toISOString().slice(0, 10)}}",
                      "author": {
                          "@type": "Organization",
                          "name": "Pharma Nord"
                      },
                      "publisher": {
                          "@type": "Organization",
                          "name": "Pharma Nord",
                          "logo": {
                              "@type": "ImageObject",
                              "url": "{{location+urlPrefix}}/static/CKFinderJava/userfiles/images/2014/general/Logo-PN-no-slogan-0514.png"
                          }
                      },
                      "description": {{JSON.stringify(item.description)}}
                  }
              </script>
            </article>
          </transition-group>
        </div>
        <button v-if="showMore" class="loadMoreNews" @click="getMoreArticles((parseInt(items.length)+parseInt($root.settings.default)));"><i :class="[loading ? 'fad fa-spinner fa-spin' : 'fad fa-angle-double-down']"></i> <webmessage searchKey="wsm_ShowMore" :text="$root.translations.wsm_ShowMore"></webmessage></button>
      
      
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  const settingsComponent = () => import('./settings.vue')
  export default {
    name: 'news',
    components: {
      axios,
      settingsComponent,
    },
    data() {
      return {
        items: [],
        itemsTotal: [],
        showMore: false,
        settingsMode: false,
        id: this.$root.settings.idForSection,
        saving: false,
        contentid: this.$root.contentid,
        loading: false,
      }
    },
    mounted() {
      this.getArticles(this.$root.settings.default ? this.$root.settings.default : 8)
    },
    methods: {
      newSettings: function(val) {
        this.items = [];
        this.id = val.id;
        this.getArticles(val.amount);
      },
      getArticles: function(amount) {
        this.loading = true;
        var requestObj = {
          target: {
            news: {
              tagId: (this.id) ? this.id : 1004325, //News section
              noOfResults: this.$root.settings.default ? this.$root.settings.default : 8
            }
          }
        }
        if (!isNaN(this.$root.cat)) {
          requestObj["attributeValueIds"] = [this.$root.cat];
          requestObj["newsId"] = 0;
          requestObj.target.news.tagId
        }
        requestObj.target.news.noOfResults = this.$root.settings.default ? this.$root.settings.default+this.items.length : 8;
        axios.post(this.basedir + "/ajaxRequestServlet?mode=Search", JSON.stringify(requestObj), {        
          headers: {
            'Content-Type': 'application/json',
          }
        }).then(response => {          
          this.itemsTotal = response.data.news // list of all items from API
          this.items = response.data.news//the items displayed                      
          
          this.loading = false;
           
          if (this.items.length >= (this.$root.settings.default ? this.$root.settings.default : 8)) {
            setTimeout(() => {
              this.showMore = true;
            }, 600)
          }
        })
      },
      getMoreArticles(val2){
       this.getArticles(val2)
      }
    },
    computed: {
      basedir: function() {
        return basedir;
      },
      locale: function() {
        return window.locale.replace('_', '-')
      },
      location: function() {
        return window.location.origin;
      },
      urlPrefix: function() {
          return basedir;
      },
    }
  }
</script>

<style>
  body,
  html {
    scroll-behavior: smooth;
  }
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  article {
    padding: 18px;
    padding-top: 0;
    min-width: 286px;
    min-height: 345px;
    vertical-align: top;
    position: relative;
    img {
      width: 100%;
      border: 1px solid #e4e4e4;
      border-radius: 5px;
    }
    h5 {
      font-size: 1em;
      margin-bottom: 5px;
      color: #2e606b;
    }
    .contentSnippet {
      width: 100%;
      display: inline-block;
      .publicationDate {
        color: #7f7f7f;
        margin: 0;
        padding: 0;
        font-size: 0.8em;
        margin-top: -3px;
        margin-bottom: 5px;
      }
    }
    .articleImage {
      vertical-align: top;
      width: 40%;
      display: inline-block;
      img {
        width: 87%;
        margin-right: 16px;
        vertical-align: top;
      }
    }
  }
  .loadMoreNews {
    width: 100%;
    padding: 10px;
    color: white;
    background: #7caf63;
    cursor: pointer;
    border: none;
    border-radius: 2px;
    &:hover {
      background: rgb(134, 190, 106);
    }
    i {
      color: white;
      margin-right: 6px;
    }
  }
  article:nth-child(odd) {
    display: inline-block;
    width: 44%;
    text-align: left;
  }
  article:nth-child(even) {
    display: inline-block;
    width: 44%;
    text-align: left;
    .articleImage {
      float: right;
    }
  }
  @media only screen and (max-width: 1030px) {
    #content article.newsItem {
      border-right: none !important;
      min-height: auto;
      a img {
        float: left !important;
        width: 33%;
        margin-top: 0 !important;
      }
    }
    article.newsItem {
      width: 100% !important;
      a img {
        float: left !important;
        width: 33%;
        margin-top: 0 !important;
      }
      .contentSnippet {
        float: right !important;
        width: 59%;
        padding-right: 16px;
        margin-bottom: 20px;
      }
    }
  }
  @media only screen and (max-width: 700px) {
    #content article.newsItem {
      border-right: none !important;
      padding: 0;
      width: 100% !important;
      min-height: auto;
      a img {
        width: 100%;
        float: none;
      }
      .contentSnippet {
        width: 100%;
        float: none !important;
      }
    }
  }
  .bounce-enter-active {
    animation: bounce-in .2s;
  }
  .bounce-leave-active {
    animation: bounce-in .2s reverse;
  }
  @keyframes bounce-in {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
    }
  }
  .heading {
    color: #00456f;
    font-weight: bold;
  }
  .settings {
    cursor: pointer;
    float: right;
    margin-top: 4px;
    font-weight: bold;
    transition: all 0.2s ease-in-out;
    &:hover {
      transform: scale(1.1)
    }
  }
  .settings.active {
    color: #4cad16;
  }
  .heading {
    height: 25px;
  }
</style>
